var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPotFood = function SvgPotFood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0H2V0.75C2 2.15937 2.6625 2.90625 3.17812 3.48438L3.19062 3.49688C3.67188 4.04063 4 4.42188 4 5.25V6H5.5V5.25C5.5 3.84063 4.8375 3.09375 4.32188 2.51562L4.30937 2.50312C3.82812 1.95937 3.5 1.57812 3.5 0.75V0ZM7 0H5.5V0.75C5.5 2.15937 6.1625 2.90625 6.67812 3.48438L6.69063 3.49688C7.17188 4.04063 7.5 4.42188 7.5 5.25V6H9V5.25C9 3.84063 8.3375 3.09375 7.82188 2.51562L7.80937 2.50312C7.32812 1.95937 7 1.57812 7 0.75V0ZM7.5 14.5V13.8469L6.66563 13.4344C4.94375 12.5813 3.73125 10.8594 3.60938 8.825L3.59063 8.50313H16.4094L16.3906 8.825C16.2719 10.8594 15.0563 12.5844 13.3344 13.4344L12.5 13.8469V14.5H7.5ZM2.05938 8H1.25H0.5V9.5H1.25H2.17188C2.50625 11.8313 3.98125 13.7781 6 14.7781V16H7.5H12.5H14V14.7781C16.0188 13.7781 17.4937 11.8313 17.8281 9.5H18.75H19.5V8H18.75H17.9406L18 7H16.4969H3.50312H2L2.05938 8ZM13.5 3.5C11.9156 3.5 10.575 4.55312 10.1438 6H16.8531C16.4219 4.55312 15.0844 3.5 13.4969 3.5H13.5Z",
    fill: "#1A1818"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white"
  })))));
};
export default SvgPotFood;